
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleGetStats } from '../../store/statsTabSlice';
import Modal from '../../components/components/modal/modal';
import ApiService from '../../components/api_services/apiService';
import styles from './GetStats.css';

function GetStats() {
    const dispatch = useDispatch();

    const isModalOpen = useSelector((state) => state.stats.getStatsOpen);
    const [isLoading, setIsLoading] = useState(false);

    // Funkcja do formatowania daty do formatu datetime-local (YYYY-MM-DDTHH:mm)
    const formatDateTimeLocal = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    // Ustawienie domyślnych dat
    const getDefaultFromDate = () => {
        const date = new Date();
        date.setDate(date.getDate() - 7); // 7 dni wstecz
        date.setHours(0, 0, 0, 0); // Początek dnia
        return formatDateTimeLocal(date);
    };

    const getDefaultToDate = () => {
        const date = new Date();
        date.setHours(23, 59, 0, 0); // Koniec dnia
        return formatDateTimeLocal(date);
    };

    const [formData, setFormData] = useState({
        from: getDefaultFromDate(),
        to: getDefaultToDate(),
    });

    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

    useEffect(() => {
        const isValid = formData.from.trim() !== '' &&
            formData.to.trim() !== '';
        setIsSubmitDisabled(!isValid);
    }, [formData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            // Konwertowanie do formatu LocalDateTime z sekundami
            const formatToLocalDateTime = (dateTimeLocal) => {
                return dateTimeLocal + ':00'; // Dodanie sekund
            };

            const fromDateTime = formatToLocalDateTime(formData.from);
            const toDateTime = formatToLocalDateTime(formData.to);

            console.log('Dane do wysłania:', { from: fromDateTime, to: toDateTime }); // Do debugowania

            // Wywołanie metody GET dla raportu Excel
            const response = await ApiService.getExcelReport(fromDateTime, toDateTime);

            // Tworzenie i pobieranie pliku
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `raport_statystyki_${formData.from.split('T')[0]}_${formData.to.split('T')[0]}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log('Raport Excel został pobrany');
            setIsLoading(false);
            dispatch(toggleGetStats());
        } catch (error) {
            console.error('Błąd podczas pobierania raportu Excel:', error);
            setIsLoading(false);
        }
    };

    const handleCloseModal = () => {
        dispatch(toggleGetStats());
    };

    return (
        <>
            {isLoading && (
                <div className="loadingOverlay">
                    <div className="spinner"></div>
                </div>
            )}
            <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
                <h2>Pobierz statystyki</h2>
                <div className="formWrapper">
                    <form onSubmit={handleSubmit} className="form">
                        <div>
                            <label htmlFor="from">Od: </label>
                            <input
                                type="datetime-local"
                                id="from"
                                name="from"
                                value={formData.from}
                                onChange={handleInputChange}
                                step="60"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="to">Do: </label>
                            <input
                                type="datetime-local"
                                id="to"
                                name="to"
                                value={formData.to}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="userView-menu modal-margin-top-20">
                            <button
                                className="buttons-modal-appearance2-almost-white"
                                type="button"
                                onClick={handleCloseModal}
                            >
                                Anuluj
                            </button>
                            <button type="submit" disabled={isSubmitDisabled || isLoading}>
                                Pobierz
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
}

export default GetStats;